import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TransitionAction } from '../../lib/transition-action.model';

@Component({
    selector: 'eas-workflow-transition-action-list',
    templateUrl: './action-list.component.html',
    styleUrls: ['./action-list.component.css'],
    standalone: false
})
export class WorkflowTransitionActionListComponent implements OnInit {

  @Input() availableActions: TransitionAction[] = [];
  @Input() actions: TransitionAction[] = [];
  @Output() editAction = new EventEmitter<string>();
  @Output() didEditActions = new EventEmitter<TransitionAction[]>();

  constructor() { }

  ngOnInit(): void { }

  //
  // Actions
  //

  public onEdit(id: string) {
    this.editAction.emit(id);
  }

  //
  // Template helpers
  //

  getCreateButtonTitle(name: string) {
    return $localize `Edit '${name}' action`;
  }
}
